<sh-card>
    <div *ngIf="isLoadingForConfigurableColumns; else columnContent">
        <sh-spinner></sh-spinner>
    </div>

    <ng-template #columnContent>
        <div class="container">
            <!-- Available Columns -->
            <div class="list">
                <sh-text size="header-1">{{'configureColumns.availableColumnHeader' | translate}}</sh-text>
                <div class="column-list">
                    <div class="column-box" *ngFor="let col of columnAvailable"
                        [class.active]="selectedAvailable.includes(col)" (click)="toggleAvailable(col)">
                        {{ col }}
                    </div>
                </div>
            </div>

            <!-- Arrow Buttons -->
            <div class="arrow-container">
                <sh-icon icon="arrow-right" size="s" (click)="moveToSelected()" style="cursor: pointer;"></sh-icon>
                <sh-icon icon="arrow-left"  size="s" (click)="moveToAvailable()" style="cursor: pointer;"></sh-icon>
            </div>
            <!-- Selected Columns -->
            <div class="list">
                <sh-text size="header-1">{{'configureColumns.selectedColumnHeader' | translate}}</sh-text>
                <div class="column-list">
                    <div class="column-box" *ngFor="let col of selectedColumns"
                        [class.active]="selectedSelected.includes(col)" (click)="toggleSelected(col)">
                        {{ col }}
                    </div>
                </div>
            </div>
        </div>
        <div class="save-btn" slot="footer">
            <sh-button (click)="saveSelectedColumns()" [label]="isSaveLoading ? ('configureColumns.isSavingButton' | translate) : ('configureColumns.saveButton' | translate)" size="auto" [disabled]="isSaveLoading"></sh-button>
        </div>
    </ng-template>
</sh-card>